import React, { useState } from "react";
import dayjs, { Dayjs } from "dayjs";
import { Box, Grid, Typography } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import LoadingButton from "@mui/lab/LoadingButton";
import { defaultStyle } from "components/Modals";
import { updatePortfolioContractsEndDate } from "api/resources/contracts";
import { Snackbar } from "types/snackbar";
import { useAppDispatch } from "hooks";
import { fetchPortfolioContracts } from "store/appSlice";

interface EditPortfolioContractModalProps {
  clientId: number;
  contractId: number;
  currentValue: string;
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
  setSnackbar: React.Dispatch<React.SetStateAction<Snackbar>>;
}

const EditPortfolioContractModal = ({
  clientId,
  contractId,
  setOpenModal,
  currentValue,
  setSnackbar,
}: EditPortfolioContractModalProps) => {
  const [loading, setLoading] = useState(false);
  const [endDate, setEndDate] = useState<Dayjs | null>(dayjs(currentValue));
  const dispatch = useAppDispatch();

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setLoading(true);

    const postData = {
      validTo: endDate ? dayjs(endDate).format("YYYY-MM-DD").toString() : "",
    };

    updatePortfolioContractsEndDate(contractId, postData)
      .then(() => {
        setLoading(false);
        setOpenModal(false);
        dispatch(fetchPortfolioContracts(clientId));
        setSnackbar({
          open: true,
          severity: "success",
          message: "Contract edited successfully",
        });
      })
      .catch((error) => {
        setSnackbar({
          open: true,
          severity: "error",
          message: error.response?.data?.message,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Box sx={defaultStyle}>
      <Typography id="modal-modal-title" variant="h5" component="h5">
        Change the end date of the contract
      </Typography>
      <Box component="form" onSubmit={handleSubmit} noValidate>
        <Grid container spacing={2} sx={{ mt: "1rem", mb: "2rem" }}>
          <Grid item sm={6}>
            <DatePicker
              label="End date"
              value={endDate}
              onChange={(newValue) => setEndDate(newValue)}
              slotProps={{ textField: { fullWidth: true, size: "small" } }}
            />
          </Grid>
          <Grid item sm={12} sx={{ mt: "1rem" }}>
            <LoadingButton
              type="submit"
              variant="contained"
              loading={loading}
              loadingIndicator="Sending..."
              disabled={loading}
            >
              Save contract
            </LoadingButton>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default EditPortfolioContractModal;
